import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import MauvelousPrimaryButton from "../../common/button/mauvelousPrimaryButton";
import { useNavigate, useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";
import ObjectionTable from "./objectionTable";
import AddObjection from "./addObjection";



export default function Index() {
  const naviagte = useNavigate();
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");

  

  return (
    <Grid
      p={page === "objectionlist" ? "none" : 3}
      sx={{
        minHeight: "50vh",
        backgroundColor:
          page === "objectionlist"  ? "none" : "#fff",
        borderRadius: "8px",
      }}
    >
      {page === "objectionlist" && (
        <Grid container>
          <Grid
            item
            md={12}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <MauvelousPrimaryButton
              title={"Add Objection"}
              handleClick={() =>
                naviagte(
                  `/${Cookies.get(
                    "mhet_mst_project"
                  )}/objection-management?page=addobjection`
                )
              }
            />
          </Grid>
          <Grid item md={12}>
            <ObjectionTable />
          </Grid>
        </Grid>
      )}
      {page === "addobjection" && <AddObjection />}
      {page === "updateobjection" && <AddObjection />}
    </Grid>
  );
}
